<template>
    <div class="content-box">
        <div class="support-index" :class="{ 'show-ticket-content': inconsistenciaSeleccionada != null }">
            <div class="support-tickets col-4">
                <div class="support-tickets-header">
                    <div class="tickets-control">
                        <h5>Inconsistencias de Tarimas</h5>
                    </div>
                    <div class="tickets-control">
                        <div class="row">
                            <div class="col-12">
                                <h6>Filtros:</h6>
                            </div>
                            <div class="col-6">
                                <label>Estado:</label>
                                <select class="form-control form-control-sm" v-model="filtro_estado"
                                    @change="refreshInconsistencias">
                                    <option value="">TODOS</option>
                                    <option value="P">PENDIENTE</option>
                                    <option value="A">APROBADO</option>
                                    <option value="R">RESUELTO</option>
                                </select>
                            </div>
                            <div class="col-6">
                                <label>Tienda Destino:</label>
                                <select class="form-control form-control-sm" v-model="tienda_origen"
                                    @change="refreshInconsistencias">
                                    <option value="">TODAS</option>
                                    <option v-for="t in tiendas" :value="t.codigo" :key="t.codigo">
                                        {{ t.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Lista de Inconsistencias -->
                <div v-for="current in inconsistencias.results" :key="current.id" class="support-ticket"
                    @click="seleccionarInconsistencia(current.id)">
                    <div class="st-meta">
                        <div class="badge badge-danger-inverted" v-if="current.estado == 'PE'">
                            {{ current.estado_display }}
                        </div>
                        <div class="badge badge-success-inverted" v-if="current.estado == 'RS'">
                            {{ current.estado_display }}
                        </div>
                        <div class="badge badge-warning-inverted" v-if="current.estado == 'AP'">
                            {{ current.estado_display }}
                        </div>
                    </div>
                    <div class="st-body">
                        <div class="ticket-content">
                            <h6 class="ticket-title">Tarima #{{ current.tarima_e_obj.numero }}</h6>
                            <div class="ticket-description">
                                De: {{ current.tarima_e_obj.tienda_origen_obj.nombre }}<br>
                                Hacia: {{ current.tarima_e_obj.tienda_destino_obj.nombre }}<br>
                                <span class="badge badge-info">
                                    {{ current.detalles_pendientes }}/{{ current.detalles_count }} pendientes
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="st-foot">
                        <span class="label">Detectado:</span>
                        <span class="value">
                            <timeago locale="es" :auto-update="60" :datetime="current.fecha_creacion"></timeago>
                        </span>
                    </div>
                </div>

                <PaginationComponent :currentPage="currentPage" :data="inconsistencias" @pagechanged="onPageChange" />
            </div>

            <!-- Panel de Detalle -->
            <div class="element-box content-box col-8" v-if="datosCompletos">
                <div class="ssupport-ticket-content" v-if="datosCompletos">
                    <div class="support-ticket-content-header">
                        <div class="header-actions">
                            <a class="back-to-index" @click="regresar" style="color: green">
                                <i class="os-icon os-icon-arrow-left5"></i> Regresar
                            </a>

                            

                            <!-- CONDICIONAL 1: Estado PENDIENTE - Mostrar solo botón Aprobar -->
                            <!-- <div v-if="puedeResolver && inconsistenciaSeleccionada.estado == 'P'"
                                class="action-buttons">
                                <button type="button" class="btn btn-warning" @click="aprobarInconsistencia"
                                    :disabled="procesando">
                                    <i class="fas fa-check-circle"></i> Aprobar Inconsistencia
                                </button>
                            </div> -->

                            <!-- CONDICIONAL 2: Estado APROBADO - Mostrar botón Acciones con dropdown -->
                            <div v-if="puedeResolver "
                                class="action-buttons">
                                <div class="btn-group">
                                    <button type="button" class="btn btn-secondary dropdown-toggle"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        :disabled="procesando">
                                        Acciones &nbsp;<i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">

                                        <button class="dropdown-item" type="button"
                                            @click="finalizarInconsistencia()"
                                            :disabled="tieneSobrantesPendientes || procesando">
                                            <i class="fas fa-check text-warning"></i>
                                            &nbsp;finalizar Inconsistencia
                                            <span v-if="contadores.sobrantes > 0" class="badge badge-warning ml-2">
                                                Pendientes - {{ contadores.sobrantes + contadores.faltantes }}
                                            </span>
                                        </button>
                                        <div class="dropdown-divider"></div>

                                    </div>
                                </div>
                            </div>

                            <!-- CONDICIONAL 3: Estado RESUELTO - Sin botones de acción -->
                            <!-- No se muestra nada adicional -->
                        </div>
                        <div style="text-align: center">
                            <h5>
                                Tarima #{{ inconsistenciaSeleccionada.tarima_e_obj.numero }}
                                
                            </h5>
                            <span :class="'badge badge-' + estadoBadgeClass">
                                {{ inconsistenciaSeleccionada.estado_display }}
                            </span>
                        </div>
                        
                    </div>
                </div>

                <div class="ticket-thread" v-if="datosCompletos">
                    <div class="ticket-reply-info">
                        <strong>Origen:</strong> {{ inconsistenciaSeleccionada.tarima_e_obj.tienda_origen_obj.nombre
                        }}<br>
                        <strong>Destino:</strong> {{inconsistenciaSeleccionada.tarima_e_obj.tienda_destino_obj.nombre }}<br>
                        <strong>Enviado por:</strong> {{ inconsistenciaSeleccionada.tarima_e_obj.usuario.name }}<br> 
                        <strong>Detectado por:</strong> {{ inconsistenciaSeleccionada.usuario_detecta_obj.name}}<br>
                        <strong>Fecha:</strong> {{ inconsistenciaSeleccionada.fecha_creacion | formatDate }}
                    </div>

                    <hr>
                    <h5>Productos con Inconsistencia</h5> 
                    <table class="table table-hover">
                    <thead class="table table-lightborder table-hover">
                        <tr>
                            <th>Producto</th>
                            <th class="text-right">Enviado</th>
                            <th class="text-right">Recibido</th>
                            <th class="text-right">Diferencia</th>
                            <th class="text-center">Estado</th>
                            <th class="text-center" v-if="puedeResolver">Acción Individual</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="faltantesPendientes.length > 0">
                            <tr class=" table-danger-soft group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-exclamation-circle mr-2"></i> FALTANTES ({{ faltantesPendientes.length }})
                                </td>
                            </tr>
                            <tr v-for="detalle in faltantesPendientes" :key="detalle.id">
                                <td>
                                    <strong>{{ detalle.producto_obj.sku }}</strong><br>
                                    <small class="text-muted">{{ detalle.producto_obj.nombre }}</small>
                                </td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right text-danger font-weight-bold">{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-pill badge-danger"><i class="far fa-clock"></i> Pendiente</span>
                                </td>
                                <td class="text-center" v-if="puedeResolver">
                                    <button class="btn btn-pill btn-outline-primary ml-1" @click="aprobarFaltante(detalle, 'retornar')" :disabled="procesando">
                                        <i class="fas fa-check">Aprobar</i> 
                                    </button>
                                    <button class="btn btn-pill btn-outline-info ml-1" @click="mostrarModalEditarInconsistencia(detalle)" :disabled="procesando">
                                        <i class="fas fa-pencil-alt">Editar</i> 
                                    </button>
                                    <button class="btn btn-pill btn-outline-danger ml-1" @click="anularDetalle(detalle)" :disabled="procesando">
                                        <i class="fas fa-times">Anular</i> 
                                    </button>
                                </td>
                            </tr>
                        </template>

                        <template v-if="sobrantesPendientes.length > 0">
                            <tr class="table-danger-soft group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-plus-circle mr-2"></i> SOBRANTES ({{ sobrantesPendientes.length }})
                                </td>
                            </tr>
                            <tr v-for="detalle in sobrantesPendientes" :key="detalle.id">
                                <td><strong>{{ detalle.producto_obj.sku }}</strong><br><small>{{ detalle.producto_obj.nombre }}</small></td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right text-success font-weight-bold">+{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-pill badge-danger"><i class="far fa-clock"></i> Pendiente</span>
                                </td>
                                <td class="text-center" v-if="puedeResolver">
                                    <button class="btn btn-pill btn-outline-success" @click="aprobarSobrante(detalle, 'aceptar')" :disabled="procesando">
                                        <i class="fas fa-check"></i> Aprobar
                                    </button>
                                    <button class="btn btn-pill btn-outline-info ml-1" @click="mostrarModalEditarInconsistencia(detalle)" :disabled="procesando">
                                        <i class="fas fa-pencil-alt">Editar</i> 
                                    </button>   
                                    <button class="btn btn-pill btn-outline-danger ml-1" @click="anularDetalle(detalle)" :disabled="procesando">
                                        <i class="fas fa-times"></i> Anular
                                    </button>
                                </td>
                            </tr>
                        </template>

                        <template v-if="detallesAprobados.length > 0">
                            <tr class="table-warning-soft group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-clipboard-check mr-2"></i> APROBADOS ({{ detallesAprobados.length }})
                                </td>
                            </tr>
                            <tr v-for="detalle in detallesAprobados" :key="detalle.id" class="text-muted">
                                <td><strong>{{ detalle.producto_obj.sku }}</strong></td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right">{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-warning"><i class="fas fa-thumbs-up"></i> Aprobado</span>
                                </td>
                                <td v-if="puedeResolver"></td>
                            </tr>
                        </template>

                        <template v-if="detallesResueltosFaltantes.length > 0">
                            <tr class="table-success group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-check-double mr-2"></i> RESUELTOS FALTANTES ({{ detallesResueltosFaltantes.length }})
                                </td>
                                <!-- <td>
                                    <router-link target="_blank" v-if="item.tipo == 'SALIDA'"
                                        class="btn btn-outline-success btn-sm" :to="{
                                        name: 'inventario-salida_inventario-editar',
                                        params: { id: item.trans_id },
                                        }">
                                        <i class="fas fa-eye"></i>
                                    </router-link>
                                </td> -->
                            </tr>
                            <tr v-for="detalle in detallesResueltosFaltantes" :key="detalle.id" class="text-muted">
                                <td><strong>{{ detalle.producto_obj.sku }}</strong></td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right">{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-success">
                                        <i class="fas fa-flag-checkered"></i> Resuelto {{ detalle.opcion_resolucion_display }}
                                    </span>
                                </td>
                                <td v-if="puedeResolver"></td>
                            </tr>
                        </template>
                        <template v-if="detallesResueltosSobrantes.length > 0">
                            <tr class="table-success group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-check-double mr-2"></i> RESUELTOS SOBRANTES ({{ detallesResueltosSobrantes.length }})
                                </td>
                                <!-- <td>
                                    <router-link target="_blank" v-if="item.tipo == 'SALIDA'"
                                        class="btn btn-outline-success btn-sm" :to="{
                                        name: 'inventario-salida_inventario-editar',
                                        params: { id: item.trans_id },
                                        }">
                                        <i class="fas fa-eye"></i>
                                    </router-link>
                                </td> -->
                            </tr>
                            <tr v-for="detalle in detallesResueltosSobrantes" :key="detalle.id" class="text-muted">
                                <td><strong>{{ detalle.producto_obj.sku }}</strong></td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right">{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-success">
                                        <i class="fas fa-flag-checkered"></i> Resuelto {{ detalle.opcion_resolucion_display }}
                                    </span>
                                </td>
                                <td v-if="puedeResolver"></td>
                            </tr>
                        </template>

                        <template v-if="detallesAnulados.length > 0">
                            <tr class="table-secondary-soft group-header-row">
                                <td colspan="6" class="font-weight-bold">
                                    <i class="fas fa-ban mr-2"></i> ANULADOS ({{ detallesAnulados.length }})
                                </td>
                            </tr>
                            <tr v-for="detalle in detallesAnulados" :key="detalle.id" class="text-muted">
                                <td><strong>{{ detalle.producto_obj.sku }}</strong></td>
                                <td class="text-right">{{ detalle.cantidad_enviada }}</td>
                                <td class="text-right">{{ detalle.cantidad_recibida }}</td>
                                <td class="text-right">{{ detalle.cantidad_diferencia }}</td>
                                <td class="text-center">
                                    <span class="badge badge-secondary">Anulado</span>
                                </td>
                                <td v-if="puedeResolver"></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editarInconsistencia" role="dialog" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <span style="font-size: 15px" class="text-success text-center">Editar Detalle de Inconsistencia</span>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center"></div>
                        <div v-if="detalleSeleccionado">
                            <h5>Producto: {{ detalleSeleccionado.producto_obj.sku }} - {{ detalleSeleccionado.producto_obj.nombre }}</h5>
                            <div class="form-group">
                                <label for="cantidadRecibida">Cantidad Recibida (General):</label>
                                <input type="number" id="cantidadRecibida" class="form-control" v-model.number="detalleSeleccionado.cantidad_recibida">
                            </div>
                            <div class="mt-4" v-if="tieneMotivoDevoluciones">
                                <h6 class="text-info border-bottom pb-2 mb-3">Registros de Inconsistencia-Motivo devolución</h6>
                                <div class="table-responsive">
                                    <table class="table table-sm table-borderless align-middle">
                                        <thead>
                                            <tr>
                                                <th>Producto</th>
                                                <th>Motivo de Devolución</th>
                                                <th style="width: 100px;">Cantidad</th>
                                                <th style="width: 50px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(registro, index) in registrosModal" :key="index">
                                                <td class="align-middle">
                                                    <small><strong>{{ detalleSeleccionado.producto_obj ? detalleSeleccionado.producto_obj.sku : ''}}</strong><br>{{ detalleSeleccionado.producto_obj ? detalleSeleccionado.producto_obj.nombre : '' }}</small>
                                                </td>
                                                <td>
                                                    <!-- <input type="text" class="form-control form-control-sm" v-model="registro.motivo_devolucion.descripcion" placeholder="Nueva descripción" :disabled="registro.id"> -->
                                                    <select  class="form-control form-control-sm" v-model="registro.motivo_devolucion.id" placeholder="Nueva descripción" :disabled="registro.id">
                                                        <option :value="null">SIN MOTIVO DEVOLUCIÓN</option>
                                                        <option v-for="(c, key) in tipo_motivo" :value="c.id" :key="key">
                                                        {{ c.descripcion }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input type="number" class="form-control form-control-sm" v-model.number="registro.recibida ">
                                                </td>
                                                <td class="align-middle text-right">
                                                    <button class="btn btn-sm btn-outline-danger" @click="eliminarRegistroModal(index)">
                                                        <i class="fas fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="registrosModal.length === 0">
                                                <td colspan="4" class="text-center text-muted py-3">No hay registros asociados</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button class="btn btn-sm btn-outline-success mt-1" @click="agregarRegistroModal" >
                                    <i class="fas fa-plus"></i> Agregar Registro
                                </button>
                            </div>

                            <hr class="mt-4">
                            <div class="text-right">
                                <button class="btn btn-primary" @click="guardarEdicionDetalle" :disabled="procesando">
                                    <i class="fas fa-save"></i> Guardar Cambios
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
    components: {
        PaginationComponent,
    },
    data() {
        return {
            inconsistencias: [],
            inconsistenciaSeleccionada: null,
            currentPage: 1,
            filtro_estado: "P",
            tienda_origen: "",
            tiendas: [],
            procesando: false,
            puedeResolver: false,
            registrosModal: [],
            tipo_motivo: "",
            detalleSeleccionado: {
            producto_obj: { sku: '', nombre: '' },
            motivo_devolucion: []
            },
            tieneMotivoDevoluciones: false,
        };
    },
    computed: {
        estadoBadgeClass() {
            if (!this.inconsistenciaSeleccionada) return '';
            const estado = this.inconsistenciaSeleccionada.estado;
            if (estado == 'P') return 'danger';
            if (estado == 'R') return 'success';
            return 'warning';
        },
        // Contadores de pendientes por tipo
        contadores() {
            if (!this.inconsistenciaSeleccionada) return { faltantes: 0, sobrantes: 0, total: 0 };

            const detalles = this.inconsistenciaSeleccionada.detalles || [];

            return {
                faltantes: detalles.filter(d =>
                    d.tipo_inconsistencia === 'FA' && d.estado === 'P'
                ).length,
                sobrantes: detalles.filter(d =>
                    d.tipo_inconsistencia === 'SO' && d.estado === 'P'
                ).length,
                total: detalles.filter(d => d.estado === 'P').length
            };
        },
        tieneFaltantesPendientes() {
            return this.contadores.faltantes > 0;
        },
        tieneSobrantesPendientes() {
            return this.contadores.sobrantes > 0;
        },
        // Obtener solo faltantes pendientes (estado P)
        faltantesPendientes() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d =>
                d.tipo_inconsistencia === 'FA' && d.estado === 'P'
            );
        },
        // Obtener solo sobrantes pendientes (estado P)
        sobrantesPendientes() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d =>
                d.tipo_inconsistencia === 'SO' && d.estado === 'P'
            );
        },
        // Obtener detalles aprobados (estado A)
        detallesAprobados() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d => d.estado === 'A');
        },
        // Obtener detalles resueltos (estado R)
        detallesResueltosFaltantes() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d => d.estado === 'R' && d.tipo_inconsistencia === 'FA');
        },
        detallesResueltosSobrantes() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d => d.estado === 'R' && d.tipo_inconsistencia === 'SO');
        },
        // Obtener detalles anulados (estado '9')
        detallesAnulados() {
            if (!this.inconsistenciaSeleccionada) return [];
            return this.inconsistenciaSeleccionada.detalles.filter(d => d.estado === '9');
        },
        datosCompletos() {
            return this.inconsistenciaSeleccionada &&
                this.inconsistenciaSeleccionada.tarima_e_obj &&
                this.inconsistenciaSeleccionada.tarima_e_obj.tienda_origen_obj &&
                this.inconsistenciaSeleccionada.tarima_e_obj.tienda_destino_obj &&
                this.inconsistenciaSeleccionada.usuario_detecta_obj;
        }
    },
    mounted() {
        this.refreshInconsistencias();
        this.refreshTiendas();
        this.verificarPermisos();
        if (this.$route.params.id) {
            this.refreshCurrent(this.$route.params.id);
        }
    },
    methods: {
        anularDetalle(detalle) {
            Notifications.alert.confirm(
                "Anular Inconsistencia",
                "¿Está seguro que desea ANULAR este detalle? Esta acción no se puede deshacer.",
                "Sí, anular",
                () => {
                    DynamicService.postAction(
                        "wms",
                        "tarima-inconsistencia",
                        this.inconsistenciaSeleccionada.id,
                        "anular_inconsistencia_detalle",
                        { detalle_id: detalle.id }
                    ).then(() => {
                        Notifications.alert.success(
                        "Inconsistencia Anulada",
                        "Se ha anulado correctamente la inconsistencia.",
                        );
                        this.refreshCurrent(this.inconsistenciaSeleccionada.id);
                        this.refreshInconsistencias();
                        this.procesando = true;
                    }).catch((err) => {
                        this.$toast.error("Error", "Error al anular el detalle", {
                            position: 'topRight'
                        });
                    }).finally(() => {
                        this.procesando = false;
                    })
                }
            );
        },
        verificarPermisos() {
            const gruposJSON = localStorage.getItem("grupos");
            const grupos = JSON.parse(gruposJSON);
            if (grupos) {
                this.puedeResolver = grupos.some(g => g.nombre === 'ProteccionActivos' || g.nombre === 'Admin');
            }
        },
        /**
         * Aprueba la inconsistencia para que pueda ser resuelta
         * Solo usuarios de ProteccionActivos pueden aprobar
         */
        aprobarInconsistencia() {
            // Solicitar observación al usuario (opcional)
            const observacion = prompt(
                'Ingrese una observación para la aprobación (opcional):\n\n' +
                'Ejemplo: "Aprobado según reporte de bodega"'
            );

            // Si el usuario cancela el prompt, no continuar
            if (observacion === null) {
                return;
            }

            // Confirmar la acción
            const confirmacion = confirm(
                '¿Confirma que desea APROBAR esta inconsistencia?\n\n' +
                'Al aprobar, se habilitarán las opciones de resolución.'
            );

            if (!confirmacion) {
                return;
            }

            this.procesando = true;

            DynamicService.postAction(
                "wms",
                "tarima-inconsistencia",
                this.inconsistenciaSeleccionada.id,
                "aprobar_inconsistencia",
                {
                    observacion: observacion || ''
                }
            )
                .then((response) => {
                    this.$toast.success(
                        'Inconsistencia aprobada correctamente',
                        'Éxito',
                        {
                            position: 'topRight',
                            timeout: 3000
                        }
                    );

                    // Refrescar la inconsistencia actual para ver el nuevo estado
                    this.refreshCurrent(this.inconsistenciaSeleccionada.id);

                    // Refrescar la lista de inconsistencias
                    this.refreshInconsistencias();
                })
                .catch((err) => {
                    console.error('Error al aprobar inconsistencia:', err);

                    const errorMsg = (err.response && err.response.data && err.response.data.detail) ||
                        'Error al aprobar la inconsistencia. Intente nuevamente.';

                    this.$toast.error(
                        errorMsg,
                        'Error',
                        {
                            position: 'topRight',
                            timeout: 5000
                        }
                    );
                })
                .finally(() => {
                    this.procesando = false;
                });
        },
        aprobarFaltante(detalle, opcion) {
            Notifications.alert.confirm(
                "Aprobar Inconsistencia Faltante",
                "Confirma que se realizó el conteo correcto y sí corresponde resolver la inconsistencia, ¿procedemos?",
                "Si",
                () => {
                    DynamicService.postAction(
                        "wms",
                        "tarima-inconsistencia",
                        this.inconsistenciaSeleccionada.id,
                        "aprobar_inconsistencia_detalle",
                        { detalle_id: detalle.id, opcion_resolucion: opcion }
                    ).then(() => {
                        Notifications.alert.success(
                        "Inconsistencia Aprobada",
                        "Se ha aprobado correctamente la inconsistencia.",
                        );
                        this.refreshCurrent(this.inconsistenciaSeleccionada.id);
                        this.refreshInconsistencias();
                        this.procesando = true;
                    }).catch((err) => {
                        this.$toast.error("Error", "Error al aprobar la inconsistencia", {
                            position: 'topRight'
                        });
                    }).finally(() => {
                        this.procesando = false;
                    })
                }
            );
        },
        aprobarSobrante(detalle, opcion) {
            const mensaje = opcion == 'aceptar' // por el momento solo una opción, se puede agregar mas opciones en el futuro
                ? '¿Confirma ACEPTAR este sobrante?'
                : '¿Confirma DEVOLVER este sobrante a CEDIS?';

            Notifications.alert.confirm(
                mensaje,
                "¿Está Seguro?",
                "sí",
                () => {
                    DynamicService.postAction(
                        "wms",
                        "tarima-inconsistencia",
                        this.inconsistenciaSeleccionada.id,
                        "aprobar_inconsistencia_detalle",
                        { detalle_id: detalle.id,   opcion_resolucion: opcion }
                    ).then(() => {
                        Notifications.alert.success(
                        "Inconsistencia Aprobada",
                        "Se ha aprobado correctamente la inconsistencia.",
                        );
                        this.refreshCurrent(this.inconsistenciaSeleccionada.id);
                        this.refreshInconsistencias();
                        this.procesando = true;
                    }).catch((err) => {
                        this.$toast.error("Error", "Error al resolver la inconsistencia", {
                            position: 'topRight'
                        });
                    }).finally(() => {
                        this.procesando = false;
                    })
                }
            );
        },
        refreshTiendas() {
            DynamicService.fetch("cat", "tiendas", {
                quitar_paginacion: false,
            }).then((response) => {
                this.tiendas = response.data;
            });
        },
        refreshMotivoDevolucion() {
            let self = this;
            DynamicService.fetch("inv", "motivo_devolucion").then((response) => {
                self.tipo_motivo = response.data.results;
            });
            },
        onPageChange(page) {
            this.currentPage = page;
            this.refreshInconsistencias();
        },
        refreshInconsistencias() {
            DynamicService.fetch("wms", "tarima-inconsistencia", {
                page: this.currentPage,
                estado: this.filtro_estado,
                tienda_destino: this.tienda_destino,
            }).then((resp) => {
                this.inconsistencias = resp.data;
            });
        },
        seleccionarInconsistencia(id) {
            this.$router.push({
                name: "wms-inconsistencias-detalle",
                params: { id: id },
            });
            this.refreshCurrent(id);
        },
        refreshCurrent(id) {
            DynamicService.getById("wms", "tarima-inconsistencia", id)
                .then((res) => {
                    this.inconsistenciaSeleccionada = res.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        regresar() {
            this.inconsistenciaSeleccionada = null;
            this.$router.push({ name: "wms-inconsistencias" });
        },
        finalizarInconsistencia() {
            if (this.contadores.total > 0) {
                this.$toast.error(
                    'No se puede finalizar la inconsistencia mientras haya pendientes de aprobar o anular',
                    'Error'
                );
                return;
            }

            Notifications.alert.confirm(
                '¿FINALIZAR tarima inconsistencia.',
                "Esta acción indica que todos los faltantes y sobrantes han sido marcados como aceptados o anulados. ¿está Seguro?",
                "Si, finalizar",
                () => {
                    this.procesando = true;
                    DynamicService.postAction(
                        "wms",
                        "tarima-inconsistencia",
                        this.inconsistenciaSeleccionada.id,
                        "finalizar_inconsistencia",
                        {}
                    ).then(() => {
                        this.$toast.success('Inconsistencia finalizada correctamente', 'Éxito', {
                            position: 'topRight'
                        });
                        this.refreshCurrent(this.inconsistenciaSeleccionada.id);
                        this.refreshInconsistencias();
                    }).catch((err) => {
                        this.$toast.error("Error", "Error al finalizar la inconsistencia", {
                            position: 'topRight'
                        });
                    }).finally(() => {
                        this.procesando = false;
                    });
                }
            );
        },
        mostrarModalEditarInconsistencia(detalle) {
            this.detalleSeleccionado = { ...detalle };

            this.refreshMotivoDevolucion();
            this.registrosModal = [];
            this.tieneMotivoDevoluciones = false;
            const registrosOrigen = detalle.tarima_producto_d_obj || [];
            const objArr = Array.isArray(registrosOrigen) ? registrosOrigen : [registrosOrigen];
            this.registrosModal = objArr.map((reg) => {
                const registro = reg ? JSON.parse(JSON.stringify(reg)) : {};
                registro.motivo_devolucion = registro.motivo_devolucion || { id: null, descripcion: '' };
                registro.cantidad = registro.cantidad !== undefined ? registro.cantidad : 0;
                registro.recibida = registro.recibida !== undefined ? registro.recibida : registro.cantidad;
                if (reg && reg.motivo_devolucion !== null) {
                    this.tieneMotivoDevoluciones = true;
                }
                return registro;
            });

            $("#editarInconsistencia").modal("show");
        },
        agregarRegistroModal() {
            this.registrosModal.push({
                cantidad: 0,
                motivo_devolucion: {
                    descripcion: ''
                }
            });
        },
        eliminarRegistroModal(index) {
            this.registrosModal.splice(index, 1);
        },
        guardarEdicionDetalle() {
            if (!this.detalleSeleccionado) return;

            this.procesando = true;
            DynamicService.postAction(
                "wms",
                "tarima-inconsistencia",
                this.inconsistenciaSeleccionada.id,
                "modificar_inconsistencia_detalle",
                {
                    detalle_id: this.detalleSeleccionado.id, //La Inconsistencia a modificar
                    cantidad_recibida: this.detalleSeleccionado.cantidad_recibida, //la cantidad recibida correcta se actualizará en tarima_producto y inconsistencia_detalle
                    registros: this.registrosModal, // Registros para modicar tarima_producto_d (cantidad y motivo de devolución) se actualizarán en base al id del registro, si no tiene id se creará uno nuevo, si el registro enviado tiene un id que no existe se eliminará el registro correspondiente
                    es_devolucion: this.tieneMotivoDevoluciones
                }
            ).then(() => {
                this.$toast.success('Detalle editado correctamente', 'Éxito', {
                    position: 'topRight'
                });
                this.refreshCurrent(this.inconsistenciaSeleccionada.id);
                this.refreshInconsistencias();
                $("#editarInconsistencia").modal("hide");
            }).catch((err) => {
                // this.$toast.error("Error", "Error al editar el detalle de la inconsistencia", {
                //     position: 'topRight'
                // });
                const errorMessage = (err.response && err.response.data && err.response.data.detail) || err.message || 'Unknown error';
                Notifications.alert.error('Error', errorMessage);
            }).finally(() => {
                this.procesando = false;
            });
        }
    },
    filters: {
        formatDate(value) {
            if (!value) return '';
            return new Date(value).toLocaleString('es-GT');
        }
    }
};
</script>


<style scoped>
/* Header actions layout */
.header-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.back-to-index {
    margin-right: auto;
    /* Empuja los botones de acción a la derecha */
}

.action-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

/* Botón de aprobar */
.btn-warning {
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.btn-warning:hover:not(:disabled) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
}

.btn-warning:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Dropdown items */
.dropdown-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    transition: background-color 0.2s ease;
}

.dropdown-item:hover:not(:disabled) {
    background-color: #f8f9fa;
}

.dropdown-item:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: transparent;
}

.dropdown-item .badge {
    font-size: 0.75rem;
    padding: 0.25em 0.5em;
    float: none;
    margin-left: 0;
}

/* Spacing for badges in dropdown */
.ml-2 {
    margin-left: 0.5rem;
}

/* Table row styling */
.table-danger td {
    background-color: #f8d7da !important;
}

.table-warning td {
    background-color: #fff3cd !important;
}

.table-success td {
    background-color: #d4edda !important;
}

/* Button group spacing */
.btn-group-sm .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .header-actions {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }

    .back-to-index {
        margin-right: 0;
        margin-bottom: 10px;
    }

    .action-buttons {
        width: 100%;
    }

    .btn-warning,
    .btn-group {
        width: 100%;
    }
}
</style>
